/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
  query CustomerAccountConnectedQuery(
    $type: CUSTOMER_TYPE!
    $isActive: Boolean!
    $take: PositiveInt
    $skip: Int
    $filter: JSONObject
  ) {
    CustomerAccountConnected(
      type: $type
      isActive: $isActive
      take: $take
      skip: $skip
      filter: $filter
    ) {
      id
      _totalCount
      displayName
      message
      status
      Smpp {
        id
        ip
        isActive
        mode
      }
    }
  }
`;
